import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import {
  PillarActionItemIconNotPrePlan,
} from 'Views/Page/Content/Templates/ClientDashboardPageTemplate/Organisms/PillarActionItemIconNotPrePlan';
import { FDStack } from '@facet-wealth/design';
import { PillarActionItemIconPrePlan } from './PillarActionItemIconPrePlan';

const useStyles = buildUseStyles('PillarActionItem', (theme) => ({
  link: {
    // Add spacing between elements without using flex so that when text wraps in the middle element the final element doesn't end up on the far right, but instead at the end of the last line of text
    '& * + *': {
      marginLeft: theme.spacing(1),
    },
  },
  linkOverdue: {
    color: theme.palette.error.main,
  },
  linkDisabled: {
    color: theme.palette.action.disabled,
  },
  linkCanComplete: {
    '&:hover': {
      cursor: 'pointer',
    },
  },
  linkCanCompletePrePlan: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  linkCompleted: {
    textDecoration: 'line-through',
  },
  nameWhenCanCompleteNotPrePlan: {
    textDecoration: 'underline',
  },
}));

export const PillarActionItem = ({ resource: actionItemResource, onClick, prePlan }) => {
  const classes = useStyles();
  const onComplete = onClick(actionItemResource);
  const isDisabled = actionItemResource.isTruthy('locked') || !onComplete;
  const isCompleted = actionItemResource.isTruthy('completed');
  const isOverdue = !isCompleted && (actionItemResource.isTruthy('overdue'));

  const addArrow = (!(isCompleted || isDisabled));

  const IconComponent = prePlan ? PillarActionItemIconPrePlan : PillarActionItemIconNotPrePlan;

  return (
    <FDStack spacing={1} alignItems={'center'}>
      <IconComponent isDisabled={isDisabled} isCompleted={isCompleted} isOverdue={isOverdue} />
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/interactive-supports-focus */}
      <span
        role={'button'}
        className={classNames(classes.link, {
          [classes.linkDisabled]: isDisabled,
          [classes.linkOverdue]: isOverdue,
          [classes.linkCanComplete]: !!onComplete,
          [classes.linkCanCompletePrePlan]: !!onComplete && prePlan,
          [classes.linkCompleted]: isCompleted,
        })}
        onClick={isDisabled ? undefined : () => {
          onComplete(actionItemResource);
        }}
      >
        <span className={onComplete && !prePlan ? classes.nameWhenCanCompleteNotPrePlan : undefined}>{actionItemResource.attr('name')}</span>
        {addArrow && <>&nbsp;&nbsp;→</>}
      </span>
    </FDStack>
  );
};

PillarActionItem.defaultProps = {
};

PillarActionItem.propTypes = {
  resource: PropTypes.object.isRequired,
  onClick: PropTypes.func.isRequired,
  prePlan: PropTypes.bool.isRequired,
};
